export interface UserClaims {
  auth_time?: number;
  aud?: string;
  email?: string;
  email_verified?: boolean;
  exp?: number;
  family_name?: string;
  given_name?: string;
  iat?: number;
  iss?: string;
  jti?: string;
  locale?: string;
  name?: string;
  nonce?: string;
  preferred_username?: string;
  sub: string;
  updated_at?: number;
  ver?: number;
  zoneinfo?: string;
  [propName: string]: any;
}

export class OktaGroup {
  id: string;
  name: string;
}

export class OktaUserProfile {
  email: string;
  primaryPhone: string;
  mobilePhone?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  displayName?: string;
  nickName?: string;
  userType?: string;
}
